var exports = {
  "k": "xe564cbfb--5609da--container",
};

module.exports = exports;
